import { render, staticRenderFns } from "./pop_seriesAdd.vue?vue&type=template&id=1490fb12&scoped=true&"
import script from "./pop_seriesAdd.vue?vue&type=script&lang=js&"
export * from "./pop_seriesAdd.vue?vue&type=script&lang=js&"
import style0 from "./pop_seriesAdd.vue?vue&type=style&index=0&id=1490fb12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1490fb12",
  null
  
)

export default component.exports